import StripedTableHead from '../../StripedTable/StripedTableHead';
import StripedTableHeadCell from '../../StripedTable/StripedTableHeadCell';
import IconDelete from '../../svg/IconDelete';
import React, { forwardRef } from 'react';

const EventCalendarTableHead = forwardRef(
    (
        {
            border,
            definitions,
            isFirstRowSelected,
            id,
            onDeleteAllClick,
            readOnly = false
        },
        ref
    ) => {
        const headCellStyle = {
            borderBottom: '1px solid #FD9A00'
        };

        return (
            <StripedTableHead id={`table-head-${id}`} ref={ref}>
                <tr id={`table-head-row-${id}`}>
                    <StripedTableHeadCell
                        id={`table-head-cell-${id}-delete`}
                        width={41}
                        border={border}
                        style={{
                            borderLeft: border
                        }}
                    >
                        <IconDelete
                            size={18}
                            fill={readOnly ? '#989898' : '#414141'}
                            disabled={readOnly}
                            onClick={onDeleteAllClick}
                        />
                    </StripedTableHeadCell>
                    {definitions.map((def, i) => (
                        <StripedTableHeadCell
                            key={`header${i}`}
                            id={`table-head-cell-${id}-${def.field}`}
                            border={border}
                            style={{
                                ...(isFirstRowSelected && headCellStyle),
                                paddingBottom: 12,
                                width: def.width
                            }}
                            height={60}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                            >
                                <span>{def.headerName}</span>
                            </div>
                        </StripedTableHeadCell>
                    ))}
                    <StripedTableHeadCell
                        id={`table-head-cell-${id}-gutter-cap`}
                        width={18}
                        border={border}
                    />
                </tr>
            </StripedTableHead>
        );
    }
);

EventCalendarTableHead.displayName = 'EventCalendarTableHead';

export default EventCalendarTableHead;
